<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="4">
        <v-autocomplete
          v-model="paramberita.location"
          :items="listlocation"
          label="Location"
          name="daerah"
          prepend-inner-icon="mdi-map-marker">
        </v-autocomplete>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          prepend-inner-icon="search"
          v-model="paramberita.keyword"
          label="Job title, keyword"
          name="keyword">
        </v-text-field>
      </v-col>
      <v-col cols="12" md="2">
        <v-btn
          class="mt-1 white--text"
          :color="maincolor"
          type="submit"
          large
          block
          @click="getJobFilter">
          <v-icon left>search</v-icon> Search
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="4">
        <v-row>
          <v-col cols="12" md="12">
            <affix
              relative-element-selector="#example-content"
              :offset="{ top: 70, bottom: 70 }"
              :class="!$vuetify.breakpoint.smAndDown ? 'container-affix-side' : 'top-zero'"
              :enabled="!$vuetify.breakpoint.smAndDown">
              <v-card
                rounded="lg"
                outlined>
                <v-container>
                  <v-row>
                    <v-col cols="12" md="12">
                      <div class="mb-1">
                        <h2 class="text-md-h6 font-weight-bold mb-3">
                          Specialization
                        </h2>
                      </div>
                      <div>
                        <v-autocomplete
                          v-model="paramberita.special"
                          :items="listspecial"
                          label="Specialization"
                          name="specialization"
                          prepend-inner-icon="mdi-account-details-outline"
                          @change="getJobFilter">
                        </v-autocomplete>
                      </div>
                    </v-col>
                    <v-col cols="12" md="12">
                      <div class="mb-1">
                        <h2 class="text-md-h6 font-weight-bold mb-3">
                          Job Type
                        </h2>
                      </div>
                      <div>
                        <v-autocomplete
                          v-model="paramberita.type"
                          :items="listtype"
                          label="Job Type"
                          name="jobtype"
                          prepend-inner-icon="mdi-account-hard-hat"
                          @change="getJobFilter">
                        </v-autocomplete>
                      </div>
                    </v-col>
                    <v-col cols="12" md="12">
                      <div class="mb-1">
                        <h2 class="text-md-h6 font-weight-bold mb-3">
                          Monthly salary range
                        </h2>
                      </div>
                      <div>
                        <span class="green--text font-weight-bold">
                          {{ paramberita.gaji[0] * 1000000 | rupiahformat }} - {{ paramberita.gaji[1] * 1000000 | rupiahformat }}
                        </span>
                        <v-range-slider
                          hint="Monthly salary range"
                          persistent-hint
                          v-model="paramberita.gaji"
                          thumb-label
                          min="1"
                          step="5"
                          prepend-icon="mdi-cash-multiple"
                          @change="getJobFilter">
                        </v-range-slider>
                      </div>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </affix>
          </v-col>
        </v-row>
      </v-col>
      <v-col id="example-content" cols="12" md="8">
        <v-row v-if="datalist.length > 0">
          <v-col
            class="d-flex" style="flex-direction:column"
            cols="12"
            md="6"
            v-for="(job, i) in datalist"
            :key="i">
            <job :job="job"></job>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <infinite-loading :identifier="infiniteId" @infinite="getJob">
          <div slot="spinner">Loading...</div>
          <div slot="no-more"></div>
          <div slot="no-results"></div>
        </infinite-loading>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../components/Alert.vue';
import Job from '../components/Job.vue';
import InfiniteLoading from 'vue-infinite-loading';
import { mapState } from 'vuex';
import { priceFromat } from '@/plugins/utils';
import { Affix } from 'vue-affix';

export default {
  name: 'Jobs',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      check: false,
    },
    api: process.env.VUE_APP_API,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    publickey: '123',
    datalist: [],
    listspecial: ['IT-Software', 'IT-Hardware', 'Hotel', 'Tourism', 'Public Relations', 'Banking', 'Accounting'],
    listlocation: ['BADUNG', 'DENPASAR', 'GIANYAR', 'TABANAN'],
    listtype: ['full-time', 'part-time', 'interenship'],
    listjenisdata: [],
    listkecamatan: [],
    panduan: null,
    paramberita: {
      special: '',
      type: '',
      location: '',
      keyword: '',
      gaji: [1, 9],
      limit: 20,
      offset: 0,
    },
    filter: {
      type: '',
      special: '',
      location: '',
      gaji: [3, 7],
      jenisdata: '',
      year: [],
      olahraga: '',
      tingkat: '',
      kelamin: '',
      kecamatan: '',
      kelurahan: '',
    },
    check: {
      reference: '',
    },
    formcheck: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
    },
    hasil: {
      headers: [
        { text: 'Tahun', value: 'tahun_prestasi' },
        { text: 'Peringkat', value: 'juara_prestasi' },
        { text: 'Tingkat', value: 'tingkat_prestasi' },
      ],
      data: [],
    },
    infiniteId: +new Date(),
  }),
  mounted() {
    if (this.$route.query.category && this.$route.query.category !== '') {
      this.paramberita.special = this.$route.query.category;
    }
    if (this.$route.query.keyword && this.$route.query.keyword !== '') {
      this.paramberita.keyword = this.$route.query.keyword;
    }
    if (this.$route.query.location && this.$route.query.location !== '') {
      this.paramberita.location = this.$route.query.location;
    }
    // this.$nextTick(function() {
    //   this.getJob(false);
    // });
  },
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
    ]),
  },
  filters: {
    // For filter render
    rupiahformat(value) {
      if (!value) {
        return '';
      } else {
        return priceFromat(value, 'Rp');
      }
    },
    dateToAge(value) {
      return value;
    },
  },
  watch: {
    // '$route.query.category'(val) {
    //   if (val) {
    //     this.paramberita.special = val;
    //     this.getJob(false);
    //   }
    // },
  },
  methods: {
    getJobFilter() {
      this.paramberita.offset = 0;
      this.datalist = [];
      this.infiniteId += 1;
    },
    getJob($state) {
      this.axios
        .get(
          this.api + '/public/jobs',
          {
            params: this.paramberita,
            headers: {
              Authorization: 'bearer ' + this.publickey,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.error === false) {
              if (resdata.data.length > 0) {
                this.paramberita.offset += this.paramberita.limit;
                resdata.data.forEach((element) => {
                  element.urlpic = this.api + '/upload/avatar/' + element.com_picture;
                  this.datalist.push(element);
                });
                // this.datalist.push(...resdata.data);
                if (this.datalist.length < this.paramberita.offset) {
                  if ($state !== false) {
                    $state.complete();
                  }
                } else {
                  if ($state !== false) {
                    $state.loaded();
                  }
                }
              } else {
                if ($state !== false) {
                  $state.complete();
                }
              }
            }
          }
          // this.loading.check = false;
        })
        .catch((error) => {
          console.log(error);
          // this.loading.check = false;
        });
    },
  },
  components: {
    Alertsp,
    InfiniteLoading,
    Affix,
    Job,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .container-affix-side{
    width: 100%;
    max-width: 370px;
  }
  .top-zero{
    top: initial !important;
  }
</style>
